import { Typography, TypographyPropsVariantOverrides } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import { OverridableStringUnion } from '@mui/types';
import styled from 'styled-components';
import { reemaColors } from './colors';

const LabelDiv = styled.div`
  margin-bottom: 4px;
  color: ${reemaColors.darkGray};
`;

interface LabeledDatumProps {
  label: string | React.JSX.Element;
  datum: number | string | React.JSX.Element;
  variant?: OverridableStringUnion<
    Variant | 'inherit',
    TypographyPropsVariantOverrides
  >;
}

export const LabeledDatum = ({
  label,
  datum,
  variant = 'labelLarge',
}: LabeledDatumProps) => {
  return (
    <div>
      <LabelDiv>
        <Typography variant={variant} component="div">
          {label}
        </Typography>
      </LabelDiv>
      <div>
        <Typography variant="bodyLarge" component="div">
          {datum}
        </Typography>
      </div>
    </div>
  );
};

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  border-radius: 8px;
`;
